import React from 'react';
import { Box, Text, Heading } from '@primer/components'
import { useProduct } from '../hooks/useProduct'


export default function() {
  const productDetails = useProduct()

  const src = productDetails.id == 'djangodoctor' ? '/diagram-dd.png' : '/diagram.png'
  return (
    <Box className="text-white pt-md-8 pt-4 pb-md-8 pb-4 hide-sm" style={{background: 'linear-gradient(to right, #363795, #005C97)'}}>
      <Box className="container-lg">
        <Heading className="mb-4 text-center">How it works</Heading>
        <Box alignItems="center" className="text-center mb-4 mb-md-0">
          <Box  style={{ padding: 20, borderRadius: 6, background: 'white'}}>
            <img src={src} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
